import { makeStyles } from '@material-ui/styles'
import React from 'react'
import CodeBlock from 'core/components/CodeBlock'
import CopyToClipboard from 'core/components/CopyToClipboard'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import Text from 'core/elements/Text'
import Theme from 'core/themes/model'

interface VmCredentialsPanelProps {
  vmPassword?: string
}

const useStyles = makeStyles<Theme>((theme) => ({
  successIcon: {
    color: theme.palette.green['700-opaque'],
    marginRight: theme.spacing(1),
  },
  credentials: {
    display: 'grid',
    gap: theme.spacing(1),
    gridTemplateColumns: '1fr 6fr',
    alignItems: 'center',
  },
}))

const VmCredentialsPanel: React.FC<VmCredentialsPanelProps> = ({ vmPassword }) => {
  const classes = useStyles()

  return (
    <>
      <Text variant="subtitle2">
        <FontAwesomeIcon solid className={classes.successIcon}>
          circle-check
        </FontAwesomeIcon>
        Congratulations! Your VM has been scheduled for creation
      </Text>

      <div>
        <Text variant="body2">
          If this is a <b>Windows VM</b>, use the credentials below to log in. Copy the password
          now, as you will not be able to view it again after you close this wizard.
        </Text>
        <Text variant="body2">
          If you are provisioning a VM with any other operating system, you can ignore these
          credentials.
        </Text>
      </div>

      <div className={classes.credentials}>
        <Text component="div" variant="body2">
          Windows Username:
        </Text>
        <CopyToClipboard copyText="Admin">
          <CodeBlock>
            <Text variant="body2" component="span">
              Admin
            </Text>
          </CodeBlock>
        </CopyToClipboard>

        <Text component="div" variant="body2">
          Password:
        </Text>
        <CopyToClipboard copyText={vmPassword || ''}>
          <CodeBlock>
            <Text variant="body2" component="span">
              {vmPassword}
            </Text>
          </CodeBlock>
        </CopyToClipboard>
      </div>
    </>
  )
}

export default VmCredentialsPanel
